import { formatCommaSeparatedNumber } from '@/utils/currency-num-pad-utils';
import { toLocaleCurrency } from '@/utils/numeric/currency';
import { renderDate } from '@/utils/renderDate';
import { formatMatchupString } from '@/utils/sport-utils';

import { BetSlipEvent } from '../types';

export const formatEventHeader = (event: BetSlipEvent) =>
    `${formatEventTeams(event)} • ${renderDate(new Date(event.start_time))}`;

export const formatEventTeams = (event: BetSlipEvent) =>
    formatMatchupString(event.home_team.short_code, event.away_team.short_code, event.sport?.name ?? '');

export const formatStakeInput = (stake: string) => {
    if (!stake || stake === '0') {
        return '$';
    }
    return `$${formatCommaSeparatedNumber(stake)}`;
};

export const fromPayoutInput = (number: number) => {
    if (!number) {
        return '$';
    }
    return toLocaleCurrency(number);
};

export const formatSocialStakeInput = (stake: string) => {
    if (!stake || stake === '0') {
        return '';
    }
    return `${formatCommaSeparatedNumber(stake)}`;
};

/**
 * Sanitizes a stake input string from onChangeText.
 * The input may contain commas from the formatted display value.
 * Returns the cleaned raw stake string, or null if the input is invalid.
 */
export const sanitizeStakeInput = (text: string, charLimit = 10): string | null => {
    // Strip commas (from formatted display value)
    const raw = text.replace(/,/g, '');

    // Empty input -> reset to '0'
    if (raw === '') {
        return '0';
    }

    // Must be numeric with at most one decimal point and max 2 decimal digits
    if (!/^\d*\.?\d{0,2}$/.test(raw)) {
        return null;
    }

    let cleaned = raw;

    // Convert bare "." to "0."
    if (cleaned === '.') {
        cleaned = '0.';
    }

    // Strip leading zeros, but keep "0." prefix
    if (cleaned.length > 1 && cleaned[0] === '0' && cleaned[1] !== '.') {
        cleaned = cleaned.replace(/^0+/, '') || '0';
    }

    // Enforce character limit
    if (cleaned.length > charLimit) {
        return null;
    }

    return cleaned;
};
